<!--
<header class="header">
  {{ header | translate }}
</header>
-->
<div style="display: flex; flex-direction: row; margin-bottom: 5px; margin-top: 5px; padding: 16px 32px">
    <i class="popup-icon fas" [ngClass]="icon"></i>

    <div style="display: flex; flex-direction: column; justify-content: center;">
      <p class="custom-message">{{ message }}</p>
    </div>

</div>

<footer class="popup-bottom">
  <button class="t-button popup-btn-approve" (click)="onOk()">
    {{ okBtnText | translate }}
  </button>


</footer>